'use client';
import { Button } from '@/components/ui/button';
import useSearch from '@/hooks/useSearch';

export default function NoPropertiesFound() {
  const { clearSearch } = useSearch();
  return (
    <div className="w-full flex flex-col justify-center items-center">
      <div className="text-xl font-milligram uppercase font-extrabold text-center mt-10 flex flex-col items-center">
        <span className="text-2xl">No properties? Major FOMO 😭</span>
        <span className="text-lg mt-4">
          We’ll tell the squad to drop more soon. <br /> Stay tuned!
        </span>
      </div>
      <div className="text-center text-slate-500 flex justify-center items-center mt-2">
        <Button variant={'default'} size={'sm'} onClick={clearSearch}>
          Reset filters
        </Button>
      </div>
    </div>
  );
}
